export default __webpack_public_path__ + "static/media/valetines-modal.ed8662e1.png";